import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-form-textarea',
    template: `
        <textarea [formControl]="fbControl"
            style="max-width: 100%;"
            [style.minHeight.px]="minHeight"
            [style.minWidth.%]="100"
            class="form-element"
            [placeholder]="placeholder"
            appValidateOnBlur>
        </textarea>
    `,
    styles: [`
        :host {
            display: block;
        }
    `]
})

export class FormTextareaComponent {
    @Input() fbControl: FormControl;
    @Input() placeholder = '';
    @Input() minHeight = 100;
}
